import React, { Component } from 'react';

export default class CategoryList extends React.Component {

    render() {
        const brStyle = {
            minHeight: '800px',
            padding: '400 0 500 0'
        };

        return (
            <div style={brStyle} >
                CategoryList
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/CategoryList.js